<template>
  <div class="small">
    <div class="logoandtext large">
      <div class="label_tot riposo_color">
        SOSTA TOT. {{ minToString(report.sosta) }}
      </div>
      <div class="label_tot guida_color">
        GUIDA MIN TOT. {{ minToString(report.guida_min) }}
      </div>
      <div class="label_tot guida_color">
        GUIDA KM TOT. {{ report.guida_km }}
      </div>
    </div>
  </div>
</template>

<script>
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'TimetableCardHistory',
  mixins: [UtilityMixin],
  props: {
    report: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {}
  },

  mounted() {
    const vm = this
  },
  methods: {},
}
</script>
<style scoped>
.small {
  font-size: 10px;
  border-bottom: 1px solid black;
  line-height: 6px;
  font-weight: bold;
  height: 40px;
}

.large {
  padding-left: 10px;
  font-size: 14px;
  height: 100%;
}

.riposo_color {
  color: green;
}

.lavoro_color {
  color: blue;
}

.guida_color {
  color: red;
}

.disp_color {
  color: orange;
}

.err_color {
  color: black;
}
.logoandtext {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
}
.logoandtext .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 48px;
}

.logoandtext .img-container img {
  max-height: 32px;
}

.logoandtext .text-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 14px;
}

.label_tot {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 10px;
}
</style>
